import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import UzenetTableService from '../service/UzenetTableService';

const config = {
	key: 'uzenetTable',
	text: 'Üzenetek',
	textKey: 'uzenetek',
	service: UzenetTableService,
	editFormState: item => `/uzenet/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh'],
	filterFields: [
		{
			text: 'Vizsgasor',
			propertyName: 'uzenetekTipus',
			propertyType: 'Long',
			type: 'EQ'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'uzenetekTipus.name',
			text: 'Típus',
			textKey: 'uzenetekTipus.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'mentValaszIn',
			text: 'Ment Válasz?',
			textKey: 'mentValaszIn',
			type: 'boolean',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'levelCim',
			text: 'Cím',
			textKey: 'levelCim',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'kuldesIdeje',
			text: 'Küldés ideje',
			textKey: 'kuldesIdeje',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		}
	]
};

function UzenetTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('uzenetTable', reducer('uzenetTable'))(UzenetTable);
